import { render, staticRenderFns } from "./EmployeeLayout.vue?vue&type=template&id=34679372&"
import script from "./EmployeeLayout.vue?vue&type=script&lang=js&"
export * from "./EmployeeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports